/**
 * Опциональная инициализация Sentry — активируется только при наличии
 * REACT_APP_SENTRY_DSN в .env. Без DSN молча выходит, чтобы не ломать билд.
 *
 * Не подключаем `@sentry/react` пакетом — используем динамический import,
 * чтобы он не попал в bundle если Sentry не используется.
 */
export async function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;
  try {
    const Sentry = await import('@sentry/react');
    Sentry.init({
      dsn,
      environment: process.env.NODE_ENV || 'production',
      tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_RATE || '0'),
      // PII не отправляем — клиентские данные чувствительны
      sendDefaultPii: false,
      beforeSend(event) {
        // Дополнительная защита: чистим URL от query-параметров с токенами
        if (event.request?.url) {
          try {
            const u = new URL(event.request.url);
            u.searchParams.delete('token');
            u.searchParams.delete('access_token');
            event.request.url = u.toString();
          } catch (e) { /* ignore */ }
        }
        return event;
      },
    });
    console.info('[sentry] инициализирован');
  } catch (e) {
    console.warn('[sentry] DSN задан, но @sentry/react не установлен. npm i @sentry/react');
  }
}
